import { HiArrowCircleRight } from 'react-icons/hi';
import { IoMdRefreshCircle } from 'react-icons/io';

import Button from '@/tayara-kit/Button';
import FeedbackMessage from '@/tayara-kit/FeedbackMessage';
import SMSInput from '@/tayara-kit/SMSInput';
import Text from '@/tayara-kit/Text';

import LoginScaffold from './LoginScaffold';

export interface SMSScreenProps {
  verifyCode: string;
  setVerifyCode: (value: string) => void;
  handleNextClick: () => void;
  reSendVerificationCode: () => void;
  error: string;
}

const SMSScreen = ({
  verifyCode,
  setVerifyCode,
  handleNextClick,
  reSendVerificationCode,
  error,
}: SMSScreenProps) => (
  <LoginScaffold>
    <div className="card-body px-0">
      <Text
        text="Saisir le code reçu par SMS"
        as="h3"
        className="mb-4 font-medium text-xl text-gray-700"
      />

      <Text
        text="Code à 6 chiffres (Obligatoire)"
        as="label"
        className="text-xs text-gray-700 font-light"
      />
      <SMSInput
        value={verifyCode}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setVerifyCode(e.target.value)
        }
      />
      {error && <FeedbackMessage text={error} />}
    </div>

    {/* Actions */}
    <div className="card-actions grid grid-cols-12 gap-x-3">
      <Button
        aria-label="Renvoyer le code"
        className="col-span-4 btn-ghost hover:bg-transparent text-gray-700 font-light text-xs"
        icon={<IoMdRefreshCircle size={16} />}
        onClick={reSendVerificationCode}
      >
        <span>Renvoyer le code</span>
      </Button>

      <Button
        aria-label="Suivant"
        className="btn-primary col-start-7 col-span-6"
        icon={<HiArrowCircleRight size={20} />}
        onClick={() => handleNextClick()}
      >
        Suivant
      </Button>
    </div>
    <LoginScaffold.NewAccountFooter text="Vous n’avez plus ce numéro ? Contactez notre service client par ici ou bien créez un nouveau compte" />
  </LoginScaffold>
);

export default SMSScreen;
